module.exports = __webpack_public_path__ + "img/icon_shop.985dbec0.svg";